import formatShortLangPrefix from './formatShortLangPrefix';
import {
  MarketoDrupalNode,
  MarketoFormFieldEntityObject,
  MarketoFormsGeneric,
  MarketoFormQueryData
} from '../types/marketo';

const contentFormIds = new Set<string | null>();
export const allMarketoForms = {} as MarketoFormsGeneric;

export const checkForMarketoFields = (page: any) => {
  contentFormIds.clear();
  Object.keys(page)
    .filter(key => key.startsWith('field') && page[key])
    .forEach(key => {
      if (Array.isArray(page[key])) {
        page[key].forEach((translation: any) => {
          retrieveMarketoIds(translation.entity, page.entityLanguage.id);
        });
      } else if (page[key].entity) {
        retrieveMarketoIds(page[key].entity, page.entityLanguage.id);
      }
    });
};

export const retrieveMarketoIds = (fieldObject: MarketoFormFieldEntityObject, nodeLangPrefix: string) => {
  if (fieldObject) {
    if (fieldObject.entityBundle === 'marketo_form') {
      const translations = fieldObject && fieldObject.entityTranslations || [fieldObject.entityTranslation];
      const matchedTranslation = translations?.find(
        (translation: any) => translation.entityLanguage.id === nodeLangPrefix
      );
      if (matchedTranslation) {
        contentFormIds.add(matchedTranslation.fieldMarketoId);
      }
    } else {
      Object.values(fieldObject).forEach(childFieldObject => {
        if (Array.isArray(childFieldObject)) {
          childFieldObject.forEach(grandkid => {
            retrieveMarketoIds(grandkid.entity, nodeLangPrefix);
          });
        } else if (childFieldObject) {
          retrieveMarketoIds(
            (childFieldObject as any).entity,
            nodeLangPrefix
          );
        }
      });
    }
  }
};

const marketoFormIds = (
  {
    page,
    langPrefix,
    cmsUrl,
    nid,
    forms
  }: {
    page: MarketoDrupalNode,
    langPrefix: string,
    cmsUrl: string,
    nid: number | string,
    forms: MarketoFormQueryData
  }
) => {
  checkForMarketoFields(page);

  forms.edges.reduce((obj, { node }) => {
    const thisObj = obj;
    thisObj[node.marketoId!] = node;

    return thisObj;
  }, allMarketoForms);

  const marketoFormIds = [...contentFormIds]
    .filter(formId => formId)
    .map(formId => formId?.trim());

  const marketoForms = marketoFormIds.reduce((previous, formId) => {
    if (!allMarketoForms[formId!]) {
      const shortLangPrefix = formatShortLangPrefix(langPrefix);
      const urlLangPrefix = langPrefix === 'en' ? '' : `${shortLangPrefix}/`;
      const errorUrl = `${cmsUrl}/${urlLangPrefix}node/${nid}/edit`;
      throw new Error(
        `Invalid Marketo form id found in node ${nid} for language ${langPrefix}: ${formId}\nYou can edit this node at ${errorUrl}`
      );
    }

    previous[formId!] = allMarketoForms[formId!];
    return previous;
  }, {} as MarketoFormsGeneric);

  return marketoForms;
};

export default marketoFormIds;
